<div class="flex bg-primary-50 h-100p">
    <section
        class="flex flex-col items-center shadow-md text-center bg-neutral-100 w-full md:w-[566px] px-4 mx-auto md:mx-auto my-12 pt-5 pb-6 rounded-lg"
    >
        <div class="flex flex-col space-y-2 items-center">
            <img
                class="max-w-[200px]"
                src="assets/images/EWA_Logo.jpg"
                alt="EWA Logo"
            />

            <div class="flex items-center flex-col pt-3 space-y-5">
                <h1 class="!mb-0">Thank you for Registering!</h1>
                <span>
                    <mat-icon
                        class="text-success-700 scale-[2.4] mt-2"
                        aria-hidden="true"
                        >task_alt</mat-icon
                    >
                </span>
                <div class="flex flex-col w-80 mx-auto space-y-2">
                    <p class="text-base text-tertiary-900 !mb-0 !mt-3">
                        All new accounts are verified.<br />
                        EWA will confirm your request shortly.
                    </p>
                    <p class="text-xs text-tertiary-900 !mb-0">
                        Please contact
                        <a
                            class="text-xs text-primary-700 underline"
                            [href]="externalLinks.enterpriseWireless.support"
                            target="_blank"
                            >Support</a
                        >
                        with any questions.
                    </p>
                </div>
            </div>
        </div>
    </section>
</div>
